import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  curso: Yup.string().required(mensagemPadrao),
  disciplina: Yup.string().required(mensagemPadrao)
})
